import { twMerge } from "tailwind-merge";

type SidebarMobileButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode
  className?: string
};

export const SidebarMobileButton = ({ children, className, ...props }: SidebarMobileButtonProps) => {
  return (
    <button
      type="button"
      {...props}
      className={twMerge(
        "rounded-lg bg-sidebar-accent dark:bg-gray-700 p-4 cursor-pointer transition-all duration-200",
        "text-sidebar-foreground",
        "hover:bg-primary/10 hover:text-primary",
        "dark:hover:bg-gray-600 dark:hover:text-primary",
        "[&>*]:hover:text-inherit [&>*]:dark:hover:text-inherit",
        "w-full text-left",
        className,
      )}
    >
      {children}
    </button>
  );
};
